<template>
  <div class="w-full">
    <div class=" text-center">
      <h3 class="gridClass font-bold text-blue-700 mb-4 text-xl lg:text-2xl">
        {{ details.title }}
      </h3>
      <div class="w-full bg-blue-300">
        <div class="gridClass grid justify-between grid-cols-2 lg:grid-cols-4 py-3">
          <div v-for="item in details.items" :key="item.id" class="py-5 lg:py-3 flex flex-col items-center" >
            <div class="w-[50px] lg:w-[70px]">
              <BaseIcon :name="item.img" />
            </div>
            <div class="font-bold mt-3 max-w-[180px] text-sm lg:text-base" >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  details: Object,
})
</script>
